import "./index.css";

const ServiceCategoryCard = ({ title, image, short_description }) => {
	return (
		<div className="card service-card">
			<div className="card-body">
				<img className="service-icon" src={`${image}`} alt="" />
				<h3 className="card-title my-1">{title}</h3>
				<p className="card-text">{short_description}</p>
			</div>
		</div>
	);
};

export default ServiceCategoryCard;
